module.exports = "<div class=\"<%= gwInputNestedButtonContainer %>\">\r\n    <div class=\"<%= gwInputNestedButtonTransclude %>\" ng-transclude></div>\r\n    <button ng-show=\"showNestedButton\" ng-click=\"onClick()\" class=\"gw-btn gw-btn-primary <%= gwInputNestedButton %>\">{{buttonLabel}}</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/inputs/input-inline-button/input-inline-button.html
// module id = 914
// module chunks = 0